import PriceType from './PriceType.container';

export default PriceType;
